var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankAccountDetailsCheckLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5004 19.8098C45.5004 20.8355 44.6689 21.667 43.6432 21.667H8.35749C7.33186 21.667 6.50041 20.8356 6.50035 19.81L6.50007 14.5043C6.50003 13.7658 6.93754 13.0975 7.61439 12.8021L25.5866 4.95892C26.0602 4.75223 26.5985 4.75222 27.0721 4.9589L44.3857 12.514C45.0625 12.8094 45.5 13.4776 45.5001 14.2161L45.5004 19.8098Z",
    fill: "#F2F4F7",
    stroke: "#3158F2",
    strokeWidth: 4.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5664 39.0003V23.4004",
    stroke: "#3158F2",
    strokeWidth: 6.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3438 37.4668L33.7898 37.4668L33.7898 35.3419L43.3438 35.3419L43.3438 37.4668Z",
    fill: "#2048E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4375 23.6602V39.0001",
    stroke: "#3158F2",
    strokeWidth: 6.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48438 23.8281H18.0384V25.3881C18.0384 26.2497 17.3399 26.9481 16.4784 26.9481H10.0444C9.18281 26.9481 8.48438 26.2497 8.48438 25.3881V23.8281Z",
    fill: "#2048E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0391 37.4668L8.48508 37.4668L8.48508 35.3419L18.0391 35.3419L18.0391 37.4668Z",
    fill: "#2048E9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0859 23.6602V39.0001",
    stroke: "#3158F2",
    strokeWidth: 6.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1367 23.8281H30.6907V25.3881C30.6907 26.2497 29.9923 26.9481 29.1307 26.9481H22.6967C21.8352 26.9481 21.1367 26.2497 21.1367 25.3881V23.8281Z",
    fill: "#2048E9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8633 37.4668L21.3093 37.4668L21.3093 35.3419L30.8633 35.3419L30.8633 37.4668Z",
    fill: "#2048E9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7891 23.8301H43.343V25.3901C43.343 26.2516 42.6446 26.9501 41.783 26.9501H35.3491C34.4875 26.9501 33.7891 26.2516 33.7891 25.3901V23.8301Z",
    fill: "#2048E9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.76945 40.1526C4.25083 41.1899 5.00508 42.4103 6.16476 42.4103H45.8365C46.9962 42.4103 47.7504 41.1899 47.2318 40.1526L46.3074 38.3038C46.0431 37.7752 45.5029 37.4414 44.912 37.4414H7.0892C6.49832 37.4414 5.95815 37.7752 5.6939 38.3038L4.76945 40.1526Z",
    fill: "#3158F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.46604 47.1999C-0.225457 48.5828 0.780214 50.2101 2.32645 50.2101H49.6754C51.2217 50.2101 52.2273 48.5829 51.5358 47.1999L50.6114 45.351C50.2591 44.6463 49.5388 44.2012 48.751 44.2012H3.25089C2.46304 44.2012 1.74282 44.6463 1.39048 45.351L0.46604 47.1999Z",
    fill: "#2048E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankAccountDetailsCheckLarge);
export default __webpack_public_path__ + "static/media/bank_account_details_check_large.516ed71ff1998a9c594d31bfbaef271a.svg";
export { ForwardRef as ReactComponent };